import { render, staticRenderFns } from "./AnnouncementCreate.vue?vue&type=template&id=3a236727&"
import script from "./AnnouncementCreate.vue?vue&type=script&lang=js&"
export * from "./AnnouncementCreate.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementCreate.vue?vue&type=style&index=0&id=3a236727&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports